/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const legislativeRoutes = {
  name: RouteName.LegislativeRoot,
  path: "legislatives",
  redirect: () => ({ name: RouteName.LegislativeFiles }),
  children: [
    {
      name: RouteName.LegislativeFiles,
      path: "",
      component: () =>
        import("@follaw-fr/views/side_menu_views/LegiWorkView.vue"),
    },
    {
      name: RouteName.LegislativeFilesFollawed,
      path: "follawed",
      component: () =>
        import("@follaw-fr/views/side_menu_views/LegiWorkView.vue"),
    },

    {
      path: ":ref",
      name: RouteName.LegislativeZoom,
      component: () =>
        import("@follaw-fr/views/side_menu_views/LegiWorkZoomView.vue"),
      redirect: { name: RouteName.LegislativeZoomTimeline },
      children: [
        {
          path: "timeline",
          name: RouteName.LegislativeZoomTimeline,
          component: () =>
            import(
              "@follaw-fr/components/legi-work/molecules/FollawedTimeline.vue"
            ),

          children: [
            {
              path: ":stepIdx",
              redirect: { name: RouteName.LegislativeTimelineInitialText },

              children: [
                {
                  path: "texte-initial",
                  name: RouteName.LegislativeTimelineInitialText,
                  component: () =>
                    import("@follaw-fr/views/legi-work/TimelineFullText.vue"),
                },
                {
                  path: "commission",
                  component: () =>
                    import("@follaw-fr/views/legi-work/TimelineCommission.vue"),
                  children: [
                    {
                      path: "full-text",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineFullText.vue"
                        ),
                    },
                    {
                      path: "amendments",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineAmendments.vue"
                        ),
                    },
                    {
                      path: "stats",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineLectureStats.vue"
                        ),
                    },
                    {
                      path: "commissions",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineCommissionsList.vue"
                        ),
                    },
                  ],
                },
                {
                  path: "seance",
                  component: () =>
                    import(
                      "@follaw-fr/views/legi-work/TimelinePublicSeance.vue"
                    ),
                  children: [
                    {
                      path: "full-text",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineFullText.vue"
                        ),
                    },
                    {
                      path: "amendments",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineAmendments.vue"
                        ),
                    },
                    {
                      path: "stats",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineLectureStats.vue"
                        ),
                    },
                  ],
                },
                {
                  path: "scrutin",
                  component: () =>
                    import("@follaw-fr/views/legi-work/ZoomScrutin.vue"),
                },
                {
                  path: "texte-scrutin",
                  component: () =>
                    import("@follaw-fr/views/legi-work/TimelineFullText.vue"),
                },
                {
                  path: "cmp_travaux",
                  component: () =>
                    import(
                      "@follaw-fr/views/legi-work/TimelineCmpGeneralInfos.vue"
                    ),
                },
                {
                  path: "cmp_lecture",
                  component: () =>
                    import("@follaw-fr/views/legi-work/TimelineFullText.vue"),
                },
                {
                  path: "49_3",
                  component: () =>
                    import(
                      "@follaw-fr/views/legi-work/TimelineQuaranteNeufTrois.vue"
                    ),
                  children: [
                    {
                      path: ":data493idx/declaration",
                      component: () =>
                        import(
                          "@follaw-fr/views/legi-work/TimelineQuaranteNeufTroisDeclaration.vue"
                        ),
                    },
                    {
                      path: ":data493idx/scrutin",
                      component: () =>
                        import("@follaw-fr/views/legi-work/ZoomScrutin.vue"),
                    },
                  ],
                },
                {
                  path: "conseil-consti",
                  component: () =>
                    import(
                      "@follaw-fr/views/legi-work/TimelineConseilConsti.vue"
                    ),
                },
                {
                  path: "prom_texte",
                  component: () =>
                    import("@follaw-fr/views/legi-work/TimelineFullText.vue"),
                },
                {
                  path: "prom_decret",
                  component: () =>
                    import("@follaw-fr/views/legi-work/TimelineDecrets.vue"),
                },
              ],
            },
          ],
        },
        {
          path: "global",
          name: RouteName.LegislativeZoomTimelineGlobal,
          component: () =>
            import("@follaw-fr/views/legi-work/LegiGlobalInfos.vue"),
        },

        {
          path: "amendments",
          name: RouteName.LegislativeZoomAmendments,
          component: () =>
            import("@follaw-fr/views/side_menu_views/AmendmentsView.vue"),
        },

        {
          path: "agenda-crs",
          name: RouteName.LegislativeZoomAgenda,
          component: () =>
            import("@follaw-fr/views/legi-work/ZoomAgendaCr.vue"),
        },
        {
          path: "social-media",
          name: RouteName.LegislativeZoomPublications,
          component: () =>
            import("@follaw-fr/views/legi-work/ZoomSocialMedia.vue"),
        },
        {
          path: "expose-motifs",
          name: RouteName.LegislativeZoomExposeDesMotifs,
          component: () =>
            import("@follaw-fr/views/legi-work/ZoomExposeMotifs.vue"),
        },
        {
          path: "infos-suppls",
          name: RouteName.LegislativeZoomAdditionalInfos,
          component: () =>
            import("@follaw-fr/views/legi-work/ZoomAdditionalInfos.vue"),
        },
      ],
    },
  ],
};
